import styled from '@emotion/styled';
import { css } from '@emotion/react';

const VisuallyHidden = styled('span')(css`
    position: absolute;
    width: 1px;
    height: 1px;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    overflow: hidden;
    white-space: nowrap;
`);

export default VisuallyHidden;
